import React, { FC, useEffect, useState } from "react";
import "./VerificationDocumentUploadCard.scss";
import { DeleteSvg } from "../../../../../../Components/Svg/deleteSvg";
import { FileSignSvg } from "../../../../../../Components/Svg/FileSignSvg";
import { MessageSvg } from "../../../../../../Components/Svg/MessageSvg";

interface propTypes {
    inputKey: string,
  title: string;
  description: string;
  value?: any;
  changeHandler?: any;
  name: string;
  doc: string;
  checkIfExist: any;
  images: Array<File>;
  removeImage: (index: number) => void;
}

const VerificationDocumentUploadCardPicker: FC<propTypes> = ({
    inputKey,
  title,
  description,
  value,
  changeHandler,
  name,
  doc,
  checkIfExist,
  images,
  removeImage,
}) => {
  const [selectedImages, setSelectedImages] = useState<Array<File>>([]);

  useEffect(() => {
    setSelectedImages(images);
  }, [images]);

  return (
    <React.Fragment>
      <div
        className={
          checkIfExist(doc)
            ? "VerificationDocumentUploadCard w-100  border-danger"
            : "VerificationDocumentUploadCard w-100"
        }
      >
        <div className="title">{title}</div>

        {selectedImages.length > 0 &&
          selectedImages.map((res: any, index) => (
            <div key={index} className="card file-upload-preview mb-1">
              <div className="card-body">
                <div className="row">
                  <div className="col-2 my-auto">
                    <MessageSvg />
                  </div>
                  <div className="col-8">
                    <div className="file-name">{res.file.name}</div>
                    <div className="row file-name mt-2">
                      <div className="col-4">
                        <div className="uploaded-size">{res.file.size}</div>
                      </div>
                      <div className="col-8 p-0">
                        <div className="uploaded-message">
                          Document Uploaded
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-2 my-auto">
                    <button
                      className="btn p-1 border-0"
                      type="button"
                      onClick={() => removeImage(Number(index))}
                    >
                      <DeleteSvg />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}

        <div className="verificationDocumentUploadCardInner mt-4">
          <label className="mb-3 file-upload" htmlFor={name}>
            <FileSignSvg />
            <input
            key={inputKey.toString()}
              id={name}
              type="file"
              accept="image/*"
              className="form-control file-upload-input"
              onChange={(event) => {
                changeHandler(event, doc);
              }}
              multiple
              value={value}
              name={name}
            />
          </label>
          <div className="document-desc">
            Drag and drop, or browse your files
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default VerificationDocumentUploadCardPicker;
